import { useContext, useState } from 'react';
import { ContextApi } from 'react-uforms';
import { AppContext } from '../../app-context';
import { useData } from '../../use-data';
import { getFileExtension } from '../helpers/file';
import { QuizContext } from '../quiz-context';
import { useQuizDocument } from './use-quiz-document';

export const useQuizManualUpload = (id: string) => {
  const api = useContext(ContextApi);
  const { addNotification, pregnancyFile, setPregnancyFile } = useContext(QuizContext);
  const { setLoading } = useContext(AppContext);
  const {
    data: {
      errors: {
        errorKey,
        uploadSizeLimit = 'Uploaded file is too big',
        uploadPregnancySupportedFormat = 'Wrong file format. Only PDF is allowed.',
      },
      keywords: { uploaded },
    },
  } = useData();

  const [isPdfUploaded, setIsPdfUploaded] = useState(false);

  const { uploadDocuments, isValidFileSize, deleteFromApi } = useQuizDocument(id, null, api);

  const { setValue } = useContext(ContextApi);
  const requiredIdentifier = `${id}_required`;

  const uploadPdf = async () => {
    setLoading(true);
    try {
      if (!isValidFileSize(pregnancyFile)) {
        addNotification({ title: uploadSizeLimit, type: 'error' });
        return;
      }
      if (!['pdf'].includes(getFileExtension(pregnancyFile.name))) {
        addNotification({ title: uploadPregnancySupportedFormat, type: 'error' });
        return;
      }
      if (await uploadDocuments([pregnancyFile], {})) {
        setValue(requiredIdentifier, 'processed');
        setIsPdfUploaded(true);
      }

      addNotification({ title: uploaded, type: 'success' });
    } catch (error) {
      addNotification({ title: errorKey, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = e => {
    setPregnancyFile(e.target.files[0]);
  };

  const handleDelete = async () => {
    await deleteFromApi(pregnancyFile);
    setValue(requiredIdentifier, '');
    setIsPdfUploaded(false);
    setPregnancyFile(null);
  };
  return {
    handleChange,
    handleDelete,
    isPdfUploaded,
    uploadPdf,
    pregnancyFile,
    requiredIdentifier,
  };
};
